import React from 'react';

const MessageWithIcon = (props) => {
  const {
    containerClassName,
    itemClassName,
    contentClassName,
    message,
    icon = 'fas fa-list-ul',
    title = ''
  } = props;

  return (
    <div className={`message__container ${containerClassName ? containerClassName : ''}`}>
      <div className={`message__item ${itemClassName ? itemClassName : ''}`}>
        <div className={`message__content ${contentClassName ? contentClassName : ''}`}>
          <div><i className={`${icon} fa-2x`}></i></div>
          {
            (title !== '') && (
              <div className="message__title">{title}</div>
            )
          }
          <div dangerouslySetInnerHTML={{__html: message}} />
        </div>
      </div>
    </div>
  )
}

export default MessageWithIcon;



// WEBPACK FOOTER //
// ./source/client/components/common/messageWithIcon.jsx